import React, { useState, useEffect } from 'react'
import Card from '../../../components/Card'
import { Row, Col, Button, Modal } from 'react-bootstrap'
import { OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getApiCall, postApiCall } from '../../../service/httpCall';
import { postApiMediaCall } from '../../../service/postApiCall';
import { API_COUNTRY_CODES_LIST, API_NUMBERS_UPLOAD, API_NUMBERS_CREATE } from '../../../service/url';
import { useNavigate } from 'react-router-dom';
import { NUMBERS_FORMAT_INDIVIDUAL, NUMBERS_FORMAT_FILE, ROUTES } from '../../../utilities/constant';
import { stripCallingCodeFromDigits, resolveCallingCodeByCountryIso } from '../../../utilities/numberCountryCode';
import RenderNumberForm from './_form';
import { useAuth, errorCheck } from '../auth/auth-utils';

const normalizeUploadResult = (result) => {
    if (!result || typeof result !== 'object') {
        return null;
    }

    const failedNumbers = Array.isArray(result.failedNumbers) ? result.failedNumbers : [];
    const successfulNumbers = Array.isArray(result.successfulNumbers)
        ? result.successfulNumbers
        : Array.isArray(result.validFreeDIDs)
            ? result.validFreeDIDs
            : [];

    return {
        totalProcessed: Number(result.totalProcessed || 0),
        successCount: Number(
            result.successCount ?? successfulNumbers.length ?? 0
        ),
        failedCount: Number(result.failedCount ?? failedNumbers.length ?? 0),
        successfulNumbers,
        failedNumbers,
        invalidFreeDIDs: Array.isArray(result.invalidFreeDIDs) ? result.invalidFreeDIDs : [],
        validFreeDIDs: Array.isArray(result.validFreeDIDs) ? result.validFreeDIDs : [],
    };
};

const formatFailedNumber = (failure) => {
    if (!failure) {
        return '';
    }

    if (typeof failure === 'string') {
        return failure;
    }

    const row = failure.row ?? failure.rowNumber;
    const did = failure.did ?? 'N/A';
    const column = failure.column || 'Validation';
    const reason = failure.reason || 'Upload failed';
    const rowLabel = row && row !== 'N/A' ? `Row ${row}` : 'Row unknown';

    return `${rowLabel} | DID ${did} | ${column}: ${reason}`;
};

export default function NumbersCreate() {

    const navigate = useNavigate();
    const { checkAuth } = useAuth();
    const [formatType, setFormatType] = useState('');
    const [countryCodeId, setCountryCodeId] = useState('');
    const [companies, setCompanies] = useState('');
    const [numberType,setNumberType] =useState('');
    const [category,setCategory] = useState('');
    const [currency,setCurrency] = useState('');
    const [did,setDid] = useState('');
    const [cost,setCost] =useState('');
    const [operator,setOperator] = useState('');
    const [stateCode,setStateCode] =useState('');
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState(null);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [uploadFile, setUploadFile] = useState(undefined);
    const [isFileUpload, setIsFileUpload] = useState(false);
    const [buttonFileDisable, setButtonFileDisable] = useState(false);
    const [actualNumber, setActualNumber] = useState('');
    const [trunks, setTrunks] = useState('');
    const [showResultModal, setShowResultModal] = useState(false);
    const [numberUploadResult, setNumberUploadResult] = useState(false);
    const [numberRoutingType, setNumberRoutingType] = useState('');
    const [countryCodesList, setCountryCodesList] = useState([]);
    
    // Set cost to 0 when category is Free
    useEffect(() => {
        if (category === 'Free') {
            setCost('0');
        }
    }, [category]);
    // useEffect(() => {
    //     if (toastProps) {
    //         setShowToast(true);
    //     }

    // }, [toastProps]);
    
    useEffect(() => {
        checkAuth(setToastProps, setShowToast);
      }, []);

    useEffect(() => {
        getApiCall(API_COUNTRY_CODES_LIST, {})
            .then((resp) => setCountryCodesList(Array.isArray(resp) ? resp : []))
            .catch(() => setCountryCodesList([]));
    }, []);

    function validateForm() {

        let valid = true;
        if (!formatType) {
            valid = false;
            // setToastProps({ message: 'Format Type required', type: 'danger' });
            toast.error("Format Type required");
        }

        else if (formatType === NUMBERS_FORMAT_FILE) {
            if (!isFileUpload && !uploadFile) {
                // setToastProps({ message: 'Numbers File is Required', type: 'danger' });
            toast.error("Numbers File is Required");
                valid = false;
            }
            if (!numberType) {
                valid = false;
                toast.error("Number Type is required");
            } else if (numberType === 'DID' && !category) {
                valid = false;
                toast.error("Category is required for DID");
            } else if (!currency) {
                valid = false;
                toast.error("Currency is required");
            }
        }
        
        else if (!numberType) {
            valid = false;
            // setToastProps({ message: 'Number Type is required', type: 'danger' });
            toast.error("Number Type is required");
        } else if (numberType === 'DID' && !category) {
            valid = false;
            // setToastProps({ message: 'Category is required for DID', type: 'danger' });
            toast.error("Category is required for DID");
        } else if (!currency) {
            valid = false;
            // setToastProps({ message: 'Currency is required', type: 'danger' });
            toast.error("Currency is required");
        } else if (numberType === 'DID' && !trunks) {
            valid = false;
            // setToastProps({ message: 'Currency is required', type: 'danger' });
            toast.error("Trunk is required");
        }
        else if (formatType === NUMBERS_FORMAT_INDIVIDUAL && !numberRoutingType) {
            valid = false;
            toast.error("Number Routing Type required");
        }
        else if (formatType === NUMBERS_FORMAT_INDIVIDUAL) {
            if (!countryCodeId) {
                valid = false;
                toast.error("Country is required");
            } else if (!did) {
                valid = false;
                // setToastProps({ message: 'DID is required', type: 'danger' });
            toast.error("DID is required");
            } else if (!cost) {
                valid = false;
                // setToastProps({ message: 'Cost is required', type: 'danger' });
            toast.error("Cost is required");
            } else if (!operator) {
                valid = false;
                // setToastProps({ message: 'Operator is required', type: 'danger' });
            toast.error("Operator is required");
            } else if (numberType === 'DID' && !stateCode) {
                valid = false;
                // setToastProps({ message: 'State Code is required for DID', type: 'danger' });
            toast.error("State Code is required for DID");
            } 
        }
        

        return valid;

    }
    

    async function submitFileForm() {

       const formData = new FormData();
        formData.append('pool', 'pool');
        formData.append('phone_numbers', uploadFile);
        formData.append("numberType", numberType);
        formData.append("category", category);
        formData.append("currency", currency);
        formData.append('phone_number', NUMBERS_FORMAT_FILE)
 
        postApiMediaCall(API_NUMBERS_UPLOAD, formData)
            .then(resp => {
                onNumbersUploadSuccess(resp);
            })
            .catch(err => {
                onNumbersUploadError(err);
            })

    }


    function onNumbersUploadError(err) {
        if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
            errorCheck(err, navigate, setToastProps, setShowToast)
         } else {
           setButtonDisable(false);
            toast.error(JSON.stringify(err));
         }
    }

    function onNumberCreateSuccess(resp) {
        // setToastProps({ message: 'Numbers created successfully', type: 'success' });
            toast.success("Numbers created successfully");
        setTimeout(() => {
            navigate(`/${ROUTES.NUMBERS.LIST}`);
        }, 1500);
    }

    function onNumbersUploadSuccess(resp) {
        const normalized = normalizeUploadResult(resp);
        setNumberUploadResult(normalized);
        setButtonDisable(false);
        setShowResultModal(true);

        if (!normalized) {
            toast.error('Upload completed but result details were unavailable.');
            return;
        }

        if (normalized.successCount > 0 && normalized.failedCount === 0) {
            toast.success(`${normalized.successCount} number(s) uploaded successfully.`);
        } else if (normalized.successCount > 0) {
            toast.warn(`Uploaded ${normalized.successCount} number(s); ${normalized.failedCount} row(s) failed.`);
        } else {
            toast.error(`No numbers were created. ${normalized.failedCount} row(s) failed validation.`);
        }
    }

    function onNumberCreateError(err) {
        if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
            errorCheck(err, navigate, setToastProps, setShowToast)
         } else {
            console.error('Number creation error:', err); 
           setButtonDisable(false);
            toast.error(JSON.stringify(err));
         }
    }

    async function submitForm(e) {

        e.preventDefault();
         
        setButtonDisable(true);
        if (!validateForm()) {
            setButtonDisable(false);
            return;
        }

        if (formatType === NUMBERS_FORMAT_FILE) {
            submitFileForm()
        }
        else if (formatType === NUMBERS_FORMAT_INDIVIDUAL) {

            const callingCode = resolveCallingCodeByCountryIso(countryCodesList, countryCodeId);
            const nationalDid = stripCallingCodeFromDigits(did, callingCode);
            const didDigits = String(did || '').replace(/\D/g, '');
            const didForApi = (nationalDid || didDigits).trim();
            if (!didForApi) {
                setButtonDisable(false);
                toast.error("DID is required");
                return;
            }

            let params = {
                countryCode: countryCodeId,
                numberType: numberType,
                currency: currency,
                DID: didForApi,
                cost: category === 'Free' ? '0' : cost, // Set cost to 0 if Free
                operator: operator,
                number_routing_type:numberRoutingType
            }
            if (numberType === 'DID') {
                params.category = category;
                params.stateCode = stateCode;
                params.trunk_id = trunks;
                } 
            
            postApiCall(API_NUMBERS_CREATE, params)
                .then(onNumberCreateSuccess)
                .catch(onNumberCreateError);
        }

    }

    return (
        <>

            <div>
                <Row>
                    <Col xl="12" lg="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">New Numbers Information</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>

                                <div className="new-trunk-info"></div>

                                <form onSubmit={async (e) => { submitForm(e) }}>

                                    <RenderNumberForm
                                        countryCodeId={countryCodeId} setCountryCodeId={setCountryCodeId}
                                        formatType={formatType} setFormatType={setFormatType}
                                        uploadFile={uploadFile} setUploadFile={setUploadFile}
                                        isFileUpload={isFileUpload} setIsFileUpload={setIsFileUpload}
                                        numberType={numberType} setNumberType={setNumberType}
                                        category={category} setCategory={setCategory}
                                        currency={currency} setCurrency={setCurrency}
                                        actualNumber={actualNumber} setActualNumber={setActualNumber}
                                        cost={cost} setCost={setCost}
                                        operator={operator} setOperator={setOperator}
                                        stateCode={stateCode} setStateCode={setStateCode}
                                        did={did} setDid={setDid}
                                        buttonFileDisable={buttonFileDisable} setButtonFileDisable={setButtonFileDisable}
                                        buttonDisable={buttonDisable} setButtonDisable={setButtonDisable}
                                        toastProps={toastProps} setToastProps={setToastProps}
                                        trunks={trunks} setTrunks={setTrunks}
                                        numberRoutingType= {numberRoutingType} setNumberRoutingType ={setNumberRoutingType}

                                    />

                                    <Button type={'submit'} variant="btn btn-primary" disabled={buttonDisable}>
                                        Add Numbers &nbsp;
                                        {
                                            buttonDisable ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></>
                                        }
                                    </Button>

                                </form>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </div>

            {/* show did result model */}
            <Modal show={showResultModal}     
            onHide={() => {
                setShowResultModal(false);
                // navigate(`/${ROUTES.NUMBERS.LIST}`);
            }} dialogClassName="w-100">
                <Modal.Header closeButton>
                    <Modal.Title>Number Upload Result</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    <div style={{ maxWidth: '800px' }}>
                        {numberUploadResult && (
                            <>
                                <div className="mb-4">
                                    <h5 className="mb-2">Upload Summary</h5>
                                    <p className="mb-1">Processed: {numberUploadResult.totalProcessed}</p>
                                    <p className="mb-1 text-success">Created: {numberUploadResult.successCount}</p>
                                    <p className="mb-0 text-danger">Failed: {numberUploadResult.failedCount}</p>
                                </div>

                                {numberUploadResult.successfulNumbers?.length > 0 && (
                                    <div className="mb-4">
                                        <h5 className="text-success mb-2">Numbers Created</h5>
                                        <textarea
                                            readOnly
                                            rows={4}
                                            className="form-control"
                                            value={numberUploadResult.successfulNumbers.join('\n')}
                                        />
                                    </div>
                                )}

                                {numberUploadResult.failedNumbers?.length > 0 && (
                                    <div className="mb-4">
                                        <h5 className="text-danger mb-2">Failed Rows</h5>
                                        <textarea
                                            readOnly
                                            rows={6}
                                            className="form-control"
                                            value={numberUploadResult.failedNumbers
                                                .map((failure) => formatFailedNumber(failure))
                                                .join('\n')}
                                        />
                                    </div>
                                )}

                                {numberUploadResult.invalidFreeDIDs?.length > 0 && (
                                    <div>
                                        <h5 className="text-danger mb-2">Free Category Cost Errors</h5>
                                        <textarea
                                            readOnly
                                            rows={4}
                                            className="form-control"
                                            value={numberUploadResult.invalidFreeDIDs
                                                .map((fail) => `${fail} - Cost is not zero for Free category`)
                                                .join('\n')}
                                        />
                                    </div>
                                )}

                                {numberUploadResult.successCount === 0 &&
                                    numberUploadResult.failedCount === 0 && (
                                        <p className="mb-0 text-muted">
                                            No rows were processed from the uploaded file.
                                        </p>
                                    )}
                            </>
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button 
                    type="button" 
                    className="btn btn-secondary" 
                    onClick={() => {
                        setShowResultModal(false);
                        // navigate(`/${ROUTES.NUMBERS.LIST}`);
                    }}
                    >
                        Close
                    </button>
                </Modal.Footer>

            </Modal>
            {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

        </>
    )

}